import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { routeConstants } from "navigation/routeConstants";

import { ReactComponent as LeftArrowIcon } from "common/assets/icons/chevron-left.svg";
import { ReactComponent as EditIcon } from "common/assets/icons/edit.svg";
import FolderItem from "common/FolderItem/FolderItem";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FileItem from "common/FileItem/FolderItem";
import { Htag } from "common/Htag/Htag";
import { Button } from "common/Button/Button";
import { P } from "common/P/P";
import Modal from "common/Modal/Modal";
import RadioButton from "common/RadioButton/RadioButton";
import { Select } from "common/Select/Select";
import { SelectItem } from "common/Select/SelectItem";
import { Input } from "common/Input/Input";
import DatePicker from "common/DatePicker/DatePicker";
import TagInput from "common/TagInput/TagInput";
import FileUpload from "common/FileUpload/FileUpload";
import axios from "axios";
import { serviceConfig } from "configs";
import { previewFile } from "utils/preview";
import PdfViewer from "common/PdfViewer/PdfViewer";

const SeeDocumentPage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const location = useLocation();
	const [documentData, setDocumentData] = useState<any>(null);
	const [selectedPdfFile, setSelectedPdfFile] = useState<string | null>(null);
	const [pdfModalOpen, setPdfModalOpen] = useState(false);

	const queryParams = new URLSearchParams(location.search);
	const pageType = queryParams.get("type");

	const [editData, setEditData] = useState<any>({
		typeSide: "",
		letterType: "",
		fromWhere: "",
		fromWho: "",
		toWhere: "",
		sentNumber: "",
		receivedDate: "",
		tags: [],
		note: "",
		files: [],
		status: "",
	});
	console.log(editData);
	const queryParamsForId = new URLSearchParams(location.search);
	const letterId = queryParamsForId.get("id");

	useEffect(() => {
		const fetchDocumentData = async () => {
			try {
				let response;

				// Extract query parameters
				const queryParams = new URLSearchParams(location.search);
				const id = queryParams.get("id");
				const type = queryParams.get("type");
				console.log("COMING", id);
				console.log("TYPE", type);

				if (type === "dgh") {
					response = await axios.get(
						`${serviceConfig.apiUrl}/dgh-letter/${id}`
					);
				} else if (type === "dih") {
					// Replace with the appropriate endpoint for DIH
					response = await axios.get(
						`${serviceConfig.apiUrl}/dih-letter/${id}`
					);
				} else if (type === "igh") {
					// Replace with the appropriate endpoint for DIH
					response = await axios.get(
						`${serviceConfig.apiUrl}/igh-letter/${id}`
					);
				} else if (type === "iih") {
					// Replace with the appropriate endpoint for DIH
					response = await axios.get(
						`${serviceConfig.apiUrl}/iih-letter/${id}`
					);
				} else if (type === "bc") {
					// Replace with the appropriate endpoint for DIH
					response = await axios.get(
						`${serviceConfig.apiUrl}/company-letters/${id}`
					);
				}
				// Add more conditions here for other types

				if (response) {
					setDocumentData(response.data.data);
				}
			} catch (error) {
				console.error("Error fetching document data:", error);
			}
		};

		fetchDocumentData();
	}, [location.search]);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isDIHModalOpen, setIsDIHModalOpen] = useState(false);
	const [isIGHModalOpen, setIsIGHModalOpen] = useState(false);

	const openModal = () => {
		setEditData({
			typeSide: documentData?.typeSide || "",
			letterType: documentData?.letterType || "",
			fromWhere: documentData?.fromWhere || "",
			fromWho: documentData?.fromWho || "",
			sentNumber: documentData?.sentNumber || "",
			receivedNumber: documentData?.receivedNumber || "",
			receivedDate: documentData?.receivedDate
				? new Date(documentData.receivedDate).toISOString().split("T")[0]
				: "",
			tags: documentData?.tags || [],
			files: documentData?.files || [],
		});
		setIsModalOpen(true);
	};

	const opendihModal = () => {
		setEditData({
			typeSide: documentData?.typeSide || "",
			letterType: documentData?.letterType || "",
			toWhere: documentData?.toWhere || "",

			sentDate: documentData?.sentDate
				? new Date(documentData.sentDate).toISOString().split("T")[0]
				: "",
			files: documentData?.files || [],
			note: documentData?.note || "",
		});
		setIsDIHModalOpen(true);
	};

	const openighModal = () => {
		setEditData({
			status: documentData?.status || "",
			sentDate: documentData?.sentDate
				? new Date(documentData.sentDate).toISOString().split("T")[0]
				: "",
			files: documentData?.files || [],
			note: documentData?.note || "",
		});
		setIsIGHModalOpen(true);
	};

	const handleInputChange = (e: any) => {
		const { name, value, type, checked } = e.target;
		if (type === "radio") {
			setEditData((prevData: any) => ({
				...prevData,
				[name]: checked ? value : prevData[name],
			}));
		} else {
			setEditData((prevData: any) => ({ ...prevData, [name]: value }));
		}
	};

	const handleDateChange = (date: any) => {
		setEditData((prevData: any) => ({ ...prevData, receivedDate: date }));
	};

	const handleUpdate = async () => {
		const formData = new FormData();

		Object.keys(editData).forEach((key) => {
			if (key === "files") {
				editData[key].forEach((file: any) => {
					formData.append("files", file);
				});
			} else if (key === "tags") {
				// Ensure that tags are an array and stringify it
				const tagsArray = Array.isArray(editData[key])
					? editData[key]
					: [editData[key]];
				formData.append(key, JSON.stringify(tagsArray));
			} else {
				formData.append(key, editData[key]);
			}
		});

		const queryParams = new URLSearchParams(location.search);
		const type = queryParams.get("type");

		try {
			const response = await axios.put(
				`${serviceConfig.apiUrl}/${type}/${documentData._id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			setDocumentData(response.data.data);
			closeModal();
			// window.location.reload();
		} catch (error) {
			console.error("Error updating document:", error);
		}
	};

	const closeModal = () => setIsModalOpen(false);
	const closeDIHModal = () => setIsDIHModalOpen(false);
	const closeIGHModal = () => setIsIGHModalOpen(false);

	const handleBackClick = () => {
		navigate(-1);
	};

	const handleFileChange = (input: any) => {
		if (input.target && input.target.files) {
			// Adding files
			const newFilesArray = Array.from(input.target.files);

			// Only add files that are not already in the state
			const updatedFilesArray = newFilesArray.filter(
				(newFile: any) =>
					!editData.files.some(
						(existingFile: any) => existingFile.name === newFile.name
					)
			);

			setEditData((prevState: any) => ({
				...prevState,
				files: [...prevState.files, ...updatedFilesArray],
			}));
		} else if (Array.isArray(input)) {
			// Removing files, input is directly the updated array
			setEditData((prevState: any) => ({
				...prevState,
				files: input,
			}));
		}
	};

	const handleTagsChange = (tags: any) => {
		setEditData((prevState: any) => ({ ...prevState, tags }));
	};

	const handleFileClick = (filePath: string) => {
		previewFile(filePath); // Call the utility function
	};

	const handlePdfClick = (pdfUrl: string) => {
		const fullUrl = `${serviceConfig.apiUrl}/${pdfUrl}`;
		setSelectedPdfFile(fullUrl);
		setPdfModalOpen(true);
	};

	return (
		<>
			{/* <FileItem
							key={idx}
							name={item.name}
							size={item.size}
							type={item.type}
						/> */}
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 pt-6 min-h-[90vh]">
				<div
					className="p-[10px] rounded-md bg-lowOpacity w-max h-max cursor-pointer"
					onClick={handleBackClick}
				>
					<LeftArrowIcon className="stroke-mainColor" />
				</div>
				<div className="grid grid-flow-row grid-cols-1 auto-rows-max">
					<div className="grid gap-4 p-6 border border-strokeColor rounded-t-md grid-cols-maxTwo place-content-between place-items-center">
						<Htag tag="h2" type="medium">
							Görmek
						</Htag>
						{pageType !== "bc" && (
							<Button
								appearance="low"
								icon={<EditIcon />}
								onClick={
									pageType === "dgh"
										? openModal
										: pageType === "dih"
										? opendihModal
										: openighModal
								}
							>
								Üýtgetmek
							</Button>
						)}
					</div>
					<div className="grid grid-cols-1 gap-8 p-6 border-b border-x border-strokeColor rounded-b-md">
						<div className="grid grid-cols-3 gap-8">
							<div className="grid grid-cols-1 gap-2">
								<P size="p3" type="regular" className="text-grayTwo">
									{pageType === "dgh" || pageType === "dih" || pageType === "bc"
										? "Tarapyň görnüşi:"
										: "Hatyň görnüşi"}
								</P>
								{pageType === "dgh" ||
								pageType === "dih" ||
								pageType === "bc" ? (
									<P size="p2" type="medium">
										{documentData?.typeSide === "Personal"
											? "Şahsy tarap"
											: documentData?.typeSide === "Administrative"
											? "Edara görnüşli tarap"
											: ""}
									</P>
								) : (
									<P size="p2" type="medium">
										{documentData?.status === "Familiarization"
											? "Tanyşdyryş"
											: documentData?.status === "Execution"
											? "Ýerine ýetirmek"
											: ""}
									</P>
								)}
							</div>
							{pageType === "dgh" || pageType === "dih" || pageType === "bc" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Hatyň görnüşi:
									</P>
									<P size="p2" type="medium">
										{documentData?.letterType}
									</P>
								</div>
							) : (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Bellik:
									</P>
									<P size="p2" type="medium">
										{documentData?.note}
									</P>
								</div>
							)}

							{pageType === "dgh" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Nireden gelen:
									</P>
									<P size="p2" type="medium">
										{documentData?.fromWhere}
									</P>
								</div>
							) : pageType === "dih" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Iberilen ýeri:
									</P>
									<P size="p2" type="medium">
										{documentData?.toWhere}
									</P>
								</div>
							) : pageType === "bc" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Gelen ýeri:
									</P>
									<P size="p2" type="medium">
										{documentData?.fromCompany}
									</P>
								</div>
							) : null}

							{/* second row */}

							{pageType === "dgh" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Kimden gelen:
									</P>
									<P size="p2" type="medium">
										{documentData?.fromWho}
									</P>
								</div>
							) : null}

							{pageType === "dgh" ? (
								<>
									<div className="grid grid-cols-1 gap-2">
										<P size="p3" type="regular" className="text-grayTwo">
											Iberilen belgisi:
										</P>
										<P size="p2" type="medium">
											{documentData?.sentNumber}
										</P>
									</div>
									<div className="grid grid-cols-1 gap-2">
										<P size="p3" type="regular" className="text-grayTwo">
											Giriş belgisi:
										</P>
										<P size="p2" type="medium">
											{documentData?.receivedNumber}
										</P>
									</div>
								</>
							) : null}

							{pageType === "dgh" ? (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Giriş senesi:
									</P>
									<P size="p2" type="medium">
										{new Date(documentData?.receivedDate)
											.toLocaleDateString("en-GB", {
												timeZone: "UTC",
												day: "2-digit",
												month: "2-digit",
												year: "numeric",
											})
											.replace(/\//g, ".")}
									</P>
								</div>
							) : (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Iberilen senesi:
									</P>
									<P size="p2" type="medium">
										{new Date(documentData?.sentDate)
											.toLocaleDateString("en-GB", {
												timeZone: "UTC",
												day: "2-digit",
												month: "2-digit",
												year: "numeric",
											})
											.replace(/\//g, ".")}
									</P>
								</div>
							)}
						</div>

						{/* third row */}

						<div className="grid grid-cols-1 gap-2">
							{documentData?.files && documentData?.files.length > 0 && (
								<div className="grid grid-cols-1 gap-2">
									<P size="p3" type="regular" className="text-grayTwo">
										Berkidilen faýllar:
									</P>
									<div className="grid grid-cols-1 gap-2 px-2 py-1 border rounded-md border-strokeColor w-max">
										{documentData?.files.map(
											(filePath: string, index: number) => {
												const normalizedPath = filePath.replace(/\\/g, "/");
												const fileName = normalizedPath.split("/").pop();

												return (
													<div
														key={index}
														className="grid grid-cols-1 px-5 py-1 rounded cursor-pointer bg-lowOpacity"
														onClick={() => handlePdfClick(normalizedPath)}
														// onClick={() => handleFileClick(normalizedPath)} // Add onClick handler
													>
														<P
															size="p3"
															type="medium"
															className="cursor-pointer text-mainColor"
														>
															{fileName}
														</P>
													</div>
												);
											}
										)}
									</div>
								</div>
							)}
						</div>

						<div className="grid grid-cols-1 gap-2">
							{documentData?.providedFilesDocs &&
								documentData?.providedFilesDocs?.length > 0 && (
									<div className="grid grid-cols-1 gap-2">
										<P size="p3" type="regular" className="text-grayTwo">
											Bagly hatlar:
										</P>
										<div className="grid grid-cols-1 gap-2 px-2 py-1 border rounded-md border-strokeColor w-max">
											{documentData?.providedFilesDocs.map(
												(file: any, index: number) => {
													return (
														<div
															key={index}
															className="grid grid-cols-1 px-5 py-1 rounded cursor-pointer bg-lowOpacity"
														>
															<P
																size="p3"
																type="medium"
																className="cursor-pointer text-mainColor"
															>
																{file.receivedNumber} - {file.fromWho} -
																{file.fromWhere}
															</P>
														</div>
													);
												}
											)}
										</div>
									</div>
								)}
						</div>
					</div>
				</div>

				{/* {pdfModalOpen && ( */}
				<PdfViewer
					fileUrl={selectedPdfFile}
					isOpen={pdfModalOpen}
					onClose={() => setPdfModalOpen(false)}
				/>
				{/* )} */}

				<Modal isOpen={isModalOpen} onClose={closeModal} title="Üýtgetmek">
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
							<P size="t1" type="regular">
								Tarapyň görnüşi
							</P>
							<div className="grid gap-6 grid-cols-maxTwo">
								<RadioButton
									id="administrative"
									name="typeSide"
									value="Administrative"
									label="Edara görnüşli tarap"
									onChange={handleInputChange}
									checked={editData.typeSide === "Administrative"}
								/>
								<RadioButton
									id="personal"
									name="typeSide"
									value="Personal"
									label="Şahsy tarap"
									onChange={handleInputChange}
									checked={editData.typeSide === "Personal"}
								/>
							</div>
						</div>
						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Select
								label="Hatyň görnüşi"
								value={editData.letterType}
								onSelect={(value) =>
									setEditData({ ...editData, letterType: value })
								}
								defaultSelectLabel=""
							>
								<SelectItem value="Arza">Arza</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
								<SelectItem value="Tender">Tender</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
							</Select>
							<Input
								appearance="default"
								type="text"
								withlabel={true}
								label="Kimden gelen"
								name="fromWho"
								value={editData.fromWho}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Input
								appearance="default"
								type="text"
								name="fromWhere"
								withlabel={true}
								label="Nireden gelen"
								value={editData.fromWhere}
								onChange={handleInputChange}
							/>
							<Input
								appearance="default"
								type="text"
								name="receivedNumber"
								withlabel={true}
								label="Giriş belgisi"
								value={editData.receivedNumber}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Input
								appearance="default"
								type="text"
								name="sentNumber"
								withlabel={true}
								label="Iberilen belgisi"
								value={editData.sentNumber}
								onChange={handleInputChange}
							/>
							<DatePicker
								label="Gelen senesi"
								value={editData.receivedDate}
								onDateChange={handleDateChange}
							/>
						</div>

						<div className="grid grid-cols-1">
							<TagInput
								placeholder=""
								label="Degişli teglar"
								tags={editData.tags}
								onChange={handleTagsChange}
							/>
						</div>

						<div className="grid grid-cols-1">
							<FileUpload
								files={editData.files}
								renderFilePaths={true}
								onChange={handleFileChange}
								type={pageType}
								letterId={letterId}
							/>
						</div>
						<div className="grid gap-4 grid-cols-maxTwo place-self-end">
							<Button
								appearance="ghost"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={closeModal}
							>
								Yza gaýtmak
							</Button>
							<Button
								appearance="main"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={handleUpdate}
							>
								Tassyklamak
							</Button>
						</div>
					</div>
				</Modal>
				<Modal
					isOpen={isDIHModalOpen}
					onClose={closeDIHModal}
					title="Üýtgetmek"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
							<P size="t1" type="regular">
								Tarapyň görnüşi
							</P>
							<div className="grid gap-6 grid-cols-maxTwo">
								<RadioButton
									id="administrative"
									name="typeSide"
									value="Administrative"
									label="Edara görnüşli tarap"
									onChange={handleInputChange}
									checked={editData.typeSide === "Administrative"}
								/>
								<RadioButton
									id="personal"
									name="typeSide"
									value="Personal"
									label="Şahsy tarap"
									onChange={handleInputChange}
									checked={editData.typeSide === "Personal"}
								/>
							</div>
						</div>
						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Select
								label="Hatyň görnüşi"
								value={editData.letterType}
								onSelect={(value) =>
									setEditData({ ...editData, letterType: value })
								}
								defaultSelectLabel=""
							>
								<SelectItem value="Arza">Arza</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
								<SelectItem value="Tender">Tender</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
							</Select>
							<Input
								appearance="default"
								type="text"
								name="toWhere"
								withlabel={true}
								label="Nirä ugradylýar"
								value={editData.toWhere}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 place-items-center">
							<DatePicker
								label="Senesi"
								value={editData.sentDate}
								onDateChange={handleDateChange}
							/>
							<Input
								appearance="default"
								type="text"
								name="note"
								withlabel={true}
								label="Gysgaça beýany"
								value={editData.note}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-1">
							<FileUpload
								files={editData.files}
								renderFilePaths={true}
								onChange={handleFileChange}
							/>
						</div>
						<div className="grid gap-4 grid-cols-maxTwo place-self-end">
							<Button
								appearance="ghost"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={closeModal}
							>
								Yza gaýtmak
							</Button>
							<Button
								appearance="main"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={handleUpdate}
							>
								Tassyklamak
							</Button>
						</div>
					</div>
				</Modal>
				<Modal
					isOpen={isIGHModalOpen}
					onClose={closeIGHModal}
					title="Üýtgetmek"
					width="w-[600px]"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<div className="grid grid-cols-1 gap-4 place-items-center">
							<DatePicker
								label="Senesi"
								value={editData.sentDate}
								onDateChange={handleDateChange}
							/>
						</div>
						<Input
							appearance="default"
							type="text"
							name="note"
							withlabel={true}
							label="Bellik"
							value={editData.note}
							onChange={handleInputChange}
						/>

						<div className="grid grid-cols-1">
							<FileUpload
								files={editData.files}
								renderFilePaths={true}
								onChange={handleFileChange}
							/>
						</div>
						<div className="grid gap-4 grid-cols-maxTwo place-self-end">
							<Button
								appearance="ghost"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={closeModal}
							>
								Yza gaýtmak
							</Button>
							<Button
								appearance="main"
								paddingX="px-5"
								paddingY="py-[10px]"
								onClick={handleUpdate}
							>
								Tassyklamak
							</Button>
						</div>
					</div>
				</Modal>
			</div>
		</>
	);
};

export default SeeDocumentPage;
